import React from 'react';
import { Row, Col } from '@zendeskgarden/react-grid';
import { XL, LG, MD, SM } from '@zendeskgarden/react-typography';
import { ItemCol, ItemRow } from './CompanyValues.styles.js';
import {  
   Truth,
   Improvement,
   Service,
   Action,
   Sustainability,
   Ownership,
  } from 'svg/svgIcons';

const CompanyValues = (props) => {
  return (
    <div>
      <Row>
        <Col size="12" style={{marginBottom: '40px'}}>
          <div>
            <XL bold  center paddingTopLg navy tag="h2"> Our Core Values</XL>
            <LG center style={{margin: '0 auto', maxWidth: '600px'}} paddingTopMd paddingBottomLg navy light tag="h3">A list of MRT core values will be essential to our success</LG>
          </div>
        </Col>
      </Row>
      
      <ItemRow>
        <ItemCol size="12" md={4}>
          <div>
            
            <MD uppercase paddingTopMd semibold blue tag="h3">Brutal Honesty</MD>
            <MD paddingBottomMd paddingTopMd slate light tag="h3">Our team, customers, and partners are why we are here. We believe being open and honest strengthens relationships, drives progress, and promotes success.
            </MD>

          </div>
        </ItemCol>


        <ItemCol size="12" md={4}>
          <div>
            
            <MD uppercase paddingTopMd semibold blue tag="h3">Hard Work And Humility</MD>
            <MD paddingBottomMd paddingTopMd slate light tag="h3">Continuous improvement is a foundation for how we live and work. We can always get better, whether it is improving a process, a relationship, technology implementation, or a habit - striving for improvement is a pillar in our philosophy. </MD>
          </div>
        </ItemCol>

        <ItemCol size="12" md={4}>
          <div>
            
            <MD uppercase paddingTopMd semibold blue tag="h3">Dependability</MD>
            <MD paddingBottomMd paddingTopMd slate light tag="h3">Helping a colleague, customer, or community is what makes us human. We believe in business and life; we live to serve others. </MD>
          </div>
        </ItemCol>

        <ItemCol size="12" md={4}>
          <div>
            
            <MD uppercase paddingTopMd semibold blue tag="h3">Exemplary Execution</MD>
            <MD paddingBottomMd paddingTopMd slate light tag="h3">The future is important in our business, our life, and the environment. We believe we have an obligation to build it right and pay it forward.</MD>
          </div>
        </ItemCol>

        <ItemCol size="12" md={4}>
          <div>
            
            <MD uppercase paddingTopMd semibold blue tag="h3">Integrity</MD>
            <MD paddingBottomMd paddingTopMd slate light tag="h3">We fundamentally believe taking action promotes long term momentum of progress. We believe in taking action today. Not tomorrow.</MD>
          </div>
        </ItemCol>
      </ItemRow>
    </div>
  )
}


export default CompanyValues;
